import { Col, Row, Space, Typography } from "antd";
import MainTechs from "./MainTechs";

const { Paragraph, Text } = Typography;
function Slacks({ screenWidth }) {
  return (
    <div style={{ margin: "1rem" }}>
      <Paragraph style={{ fontSize: "1.5rem", textAlign: "center" }} strong>
        SERVICES AND{" "}
        <Text style={{ color: "#0abacc", fontSize: "1.5rem" }}> SLACKS</Text>
      </Paragraph>
      <Paragraph
        style={{
          border: "1px solid #D04A1060",
          // background: "#D04A10",
          padding: screenWidth < 800 ? "1rem " : "1vh 1vw",
          textAlign: "left",
          borderRadius: "7px",
          // color: "#00000090",
        }}
        ellipsis={{ rows: 2, expandable: true, symbol: "read more" }}
      >
        I've accumulated over six years of experience in software development
        for a diverse clientele around the world. Below, you'll find a concise
        summary of my main technical skill sets and the technologies I employ.
        To delve further into my professional history, please explore my resume
        and project portfolio.
      </Paragraph>

      <Row>
        {MainTechs.sort((a, b) => {
          const titleA = a.title.toUpperCase();
          const titleB = b.title.toUpperCase();
          if (titleA < titleB) {
            return -1;
          }
          if (titleA > titleB) {
            return 1;
          }
          return 0;
        }).map((x) => (
          <Col xs={24} md={8} xl={6} className="card-s" key={x.title}>
            <div style={{ padding: screenWidth < 600 ? "1rem" : "0.8rem" }}>
              <Space>
                <Text>{x.icon} </Text>
                <Paragraph style={{ margin: 0 }}>
                  <Text strong>{x.title}</Text> <br />
                  <Text style={{ color: "gray" }}>{x.category}</Text>
                </Paragraph>
              </Space>
              <Paragraph
                style={{ marginTop: "1rem" }}
                ellipsis={{ rows: 2, expandable: true, symbol: "more" }}
              >
                {x.description}
              </Paragraph>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default Slacks;
